import {useContext} from 'react';
import {AdminItemStoreContext} from 'stores/contexts/AdminItemStore';

export const useAdminItemStore = () => useContext(AdminItemStoreContext);
